<template>
  <div class="login">
    <div id="login" class="sec mt-10">
      <v-container>
        <v-row justify="center">
          <div class="display-2 head" data-aos="fade-up">Log in</div>
        </v-row>

        <v-card
          flat
          rounded="lg"
          data-aos="fade-up"
        >
          <v-row>
            <v-col
              cols="6"
              class="ma-0 pa-0 hidden-sm-and-down"
            >
              <v-img
                width="100%"
                height="100%"
                src="@/assets/images/others/login.jpg"
                class="left-image"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <div class="form">
                <h1 class="pb-3 primary--text">Welcome!</h1>

                <v-form>
                  <v-text-field
                    label="Email"
                  ></v-text-field>
                  <v-text-field
                    label="Password"
                  ></v-text-field>
                </v-form>

                <v-card-actions>
                  <v-btn
                    rounded
                    depressed
                    x-large
                    color="#c2dffc"
                    :min-width="$vuetify.breakpoint.xs ? '50%' : '40%'"
                    class="blue--text text--darken-2"
                  >
                    Login
                  </v-btn>
                  <v-btn
                    rounded
                    depressed
                    x-large
                    color="#0e6ccd"
                    :min-width="$vuetify.breakpoint.smAndDown ? '50%' : '40%'"
                    class="white--text"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>

                <div class="pt-5">
                  <router-link to="/">
                    <p>Reset Password</p>
                  </router-link>

                  <p>Not a member yet?
                    <router-link to="/register">
                      Create your account
                    </router-link>
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Login",
  components: {
  },
  data() {
    return {
      username: '',
      password: '',
      successMsg: ''
    }
  },
  mounted() {
    //
  },
  methods: {
    login() {
      var data = new FormData();
      data.append('username', this.username);
      data.append('password', this.password);

      this.$axios.post('http://medgate-env.eba-xebxjwxd.ap-southeast-1.elasticbeanstalk.com/api/v1/user/login', data)
      .then((response) => {
          console.log(response);
          console.log("LOGGED IN");
          this.successMsg = "YAHOO!"
      })
      .catch((error) => { 
          console.log(error.response.data);
      })
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.form {
  padding: 10%;
}

.left-image {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
</style>